module.exports = __webpack_public_path__ + "assets/img/icon2-menu.925036e5.svg";